import * as types from './mutation-types'

let defaultObject = () => ({
  data: {
    code: '',
    name: '',
    native_name: '',
    flag: '',
    is_default: false,
    is_active: true,
    sort_order: 0
  }
})

export default {
  [types.SET_LANGUAGE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.language = payload
  },
  [types.SET_LANGUAGES] (state, payload) {
    state.languages = payload.data
    // Laravel paginate() returns pagination info at root level
    state.pagination = {
      total: payload.total || 0,
      current_page: payload.current_page || 1,
      per_page: payload.per_page || 50,
      last_page: payload.last_page || 1
    }
  }
}
